export default "__VITE_ASSET__126f9f64__"